module.exports = __webpack_public_path__ + "img/pv-05.ef9754de.svg";